export enum CookieProCategory {
  StrictlyNecessary = 'C0001',
  Performance = 'C0002',
  Functional = 'C0003',
  Marketing = 'C0004',
  SocialMedia = 'C0005',
}
